export default __webpack_public_path__ + "static/experts-icon-20807a1660719a83c01ade51ff9f6b55.svg";